import { render, staticRenderFns } from "./SaveTemplateBtn.vue?vue&type=template&id=214e33af&"
import script from "./SaveTemplateBtn.vue?vue&type=script&lang=ts&"
export * from "./SaveTemplateBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports